import { t } from 'localization'
import sendTrackingEvent from 'mParticle/sendTrackingEvent'
import { useEffect, useState } from 'react'
import { SortOption } from 'search/enums/search'
import { SVGIcon } from 'shared/components/Icons'
import { SearchQA } from 'shared/dataAttributes'
import { fonts, media } from 'shared/lib'
import colors from 'shared/lib/colors'
import styled from 'styled-components'

const TP = 'search.components.searchSort'

const StyledCaret = styled(SVGIcon)`
  margin-top: 6px;
  width: 14px;
  pointer-events: none;
  transform: translateY(-50%);
  ${media.large`
    margin-top: 0px;
    position: absolute;
    right: 15px;
    top: 40%;
  `}
`

const SelectBox = styled.div<{ fullWidth: boolean }>`
  display: flex;
  align-items: center;
  ${fonts.LINK};
  text-decoration: none;
  height: 35px;
  justify-content: right;
  background-color: transparent;
  width: ${({ fullWidth }) => (fullWidth ? '260px' : '200px')};
  bottom: 2px;
  ${media.large`
    height: 40px;
    position: relative;
    background-color: transparent;
    width: ${({ fullWidth }) => (fullWidth ? '260px' : '200px')};
    bottom: 12px;
    left: 15px;
  `}
`

const Select = styled.select<{ fullWidth: boolean }>`
  appearance: none;
  height: 100%;
  border-radius: 0;
  font-weight: 500;
  color: ${({ disabled }) => (disabled ? colors.FC2_GREY : colors.FC2_BLACK)};
  text-decoration: underline;
  width: ${({ fullWidth }) => (fullWidth ? '130px' : '65px')};
  padding-left: 5px;
  background-color: transparent;
  border: none;
  ${media.large`
    width: 100%;
    padding: 10px 35px 9px 98px;
    background-color: transparent;
    border: none;
  `}
`

const SortByLabel = styled.label`
  ${media.large`
    position: absolute;
    left: 40px;
  `}
`

interface SortOption {
  value: string
  label: string
}

export const SearchSort = ({
  items,
  currentRefinement,
  refine,
}: {
  items: SortOption[]
  currentRefinement: string
  refine: (a: string) => void
}) => {
  useEffect(() => {
    if (currentRefinement !== selection) {
      setSelection(currentRefinement)
    }
  }, [currentRefinement])

  const [selection, setSelection] = useState(currentRefinement)
  const handleChange = (e) => {
    const value = e.currentTarget.value
    const selectedSortLabel = e.currentTarget
      .querySelector(`option[value=${value}]`)
      .innerHTML.toLowerCase()
      .replace(' ', '_')
    setSelection(value)
    sendTrackingEvent('SORT_APPLY_TAP', {
      page: window?.location?.href,
      sort_by: selectedSortLabel,
    })
    refine(value)
  }

  const isFullWidth = (value: string) => {
    switch (value) {
      case SortOption.PriceLowHigh:
      case SortOption.PriceHighLow:
        return true
      default:
        return false
    }
  }

  return (
    <SelectBox fullWidth={isFullWidth(selection)}>
      <SortByLabel htmlFor="GridSortFilter">{t(`${TP}.sortBy`, 'Sort By:')}</SortByLabel>
      <Select
        id="GridSortFilter"
        data-qa={SearchQA.GridSortByFilter}
        value={selection}
        onChange={handleChange}
        fullWidth={isFullWidth(selection)}
      >
        {items.map((item) => (
          <option key={item.value} value={item.value}>
            {item.label}
          </option>
        ))}
      </Select>
      <StyledCaret name="caret" color={colors.FC2_GREY} />
    </SelectBox>
  )
}
